import { THREE_FOURS_SHOW_MODAL, THREE_FOURS_HIDE_MODAL } from './constants';

export default function (state = null, action) {
  switch (action.type) {
    case THREE_FOURS_SHOW_MODAL:
      return { ...state, isModalOpen: true };
    case THREE_FOURS_HIDE_MODAL:
      return { ...state, isModalOpen: false };
    default:
      return state;
  }
}
